import { AfterViewInit, Component, EventEmitter, Inject, Input, OnInit, Optional, Output, TemplateRef, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { LeaderboardService, SellerService } from 'src/app/core';
import { DataTableColumn } from 'src/app/shared/ui/data-table/data-table.component';

@Component({
  selector: 'app-activity-challenge-documents',
  templateUrl: './activity-challenge-documents.component.html',
  styleUrls: ['./activity-challenge-documents.component.scss']
})
export class ActivityChallengeDocumentsComponent implements OnInit, AfterViewInit {

  @Input() inputData: any;
  @Output() documentClosed = new EventEmitter<boolean>();

  @ViewChild('filenameCellTemplate') filenameCellTemplate!: TemplateRef<any>;
  @ViewChild('uploadCellTemplate') uploadCellTemplate!: TemplateRef<any>;
  @ViewChild('termsCellTemplate') termsCellTemplate!: TemplateRef<any>;

  data: any;
  tableColumns: DataTableColumn[] = [];
  tableRows: any[] = [];
  errorMessage: string = '';

  uploadFileCategoryList: any[] = [
    { label: 'Terms And Conditions', value: 'TERMS_AND_CONDITIONS', fileData: null, fileUploadSuccess: false },
    { label: 'Others', value: 'OTHERS', fileData: null, fileUploadSuccess: false }
  ];

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) private dialogData: any,
    private sellerService: SellerService,
    private leaderboardService: LeaderboardService
  ) { }

  ngOnInit() {
    this.data = this.inputData || this.dialogData;
  }

  ngAfterViewInit() {
    this.buildTable();
  }

  buildTable() {
    if (this.data.showOnlyTerms) {
      this.tableColumns = [
        { field: 'label', header: 'Category' },
        { field: 'url', header: 'Filename', cellTemplate: this.termsCellTemplate }
      ];
      this.tableRows = [{
        label: 'Terms And Conditions',
        url: this.data.fileData.termsAndConditionsUrl || 'N/A'
      }];
    } else {
      const cols: DataTableColumn[] = [
        { field: 'label', header: 'Category' },
        { field: 'filename', header: 'Filename', cellTemplate: this.filenameCellTemplate }
      ];
      if (this.data.name === 'uploadDocuments') {
        cols.push({ field: 'upload', header: 'Upload File', cellTemplate: this.uploadCellTemplate });
      }
      this.tableColumns = cols;
      this.tableRows = this.uploadFileCategoryList;
    }
  }

  downloadFile(category: any) {
    const fileUrl = this.data.fileData.attachments
      .filter((att: any) => att.category === category.value)[0].url;
    const newWindow = window.open(fileUrl, '_blank');
    if (newWindow) {
      newWindow.focus();
    }
  }

  downloadTermsFile(fileUrl: string) {
    const newWindow = window.open(fileUrl, '_blank');
    if (newWindow) {
      newWindow.focus();
    }
  }

  getFileName(category: any): string {
    const match = this.data.fileData.attachments
      .filter((att: any) => att.category === category.value);
    return match.length > 0 ? match[0].name : '';
  }

  getFile(eve: any, category: any) {
    category.fileData = eve.target.files[0];
  }

  uploadFile(fileData: any, category: any) {
    const uploadData = new FormData();
    uploadData.append('file-to-be-uploaded', fileData);

    if (this.data.path === 'leaderboard') {
      const reqParams = '?leaderboardChallengeId=' + this.data.fileData.id
        + '&fileName=' + fileData.name + '&category=' + category.value;

      this.leaderboardService.uploadLeaderboardChgDocuments(uploadData, reqParams).subscribe(
        (res: any) => {
          if (res) {
            category.fileUploadSuccess = true;
            this.updateFilename(res, category);
            this.documentClosed.emit(true);
          }
        },
        (error: any) => {
          this.errorMessage = error.status === 500 ? 'Something went wrong' : error.message;
        }
      );
    } else {
      const challengeId = this.data.fileData.id;
      const params = '?activityChallengeId=' + challengeId
        + '&fileName=' + fileData.name + '&category=' + category.value;

      this.sellerService.uploadActivityChallengeDocuments(uploadData, params).subscribe(
        (response: any) => {
          if (response) {
            category.fileUploadSuccess = true;
            this.updateFilename(response, category);
            this.documentClosed.emit(true);
          }
        },
        (error: any) => {
          this.errorMessage = error.status === 500 ? 'Something went wrong' : error.message;
        }
      );
    }
  }

  updateFilename(res: any, category: any) {
    const attachments = this.data.fileData.attachments;
    const existing = attachments.filter((att: any) => att.category === category.value);

    if (existing.length === 0) {
      attachments.push(res);
    } else {
      const index = attachments.findIndex((ele: any) => ele.category === category.value);
      if (index !== -1) {
        attachments.splice(index, 1, res);
      }
    }
  }
}
